module.exports = __webpack_public_path__ + "img/appstore.f0fabd93.png";